module.exports = __webpack_public_path__ + "img/times-banner.d2e460b7.jpg";